// 传入stationCode 以用于列表请求
export let props = ['stationCode'];

export let model = {
  // 通知对象
  notifications:[],
  // 轮询定时器
  refreshinterval: undefined,
  tradeMissInterval:undefined,
  // 车型不一致
  conflictList: {
    input: {
      value: {
        page: 1,
        pageSize: 10,
        // queryState: 3,
        queryType: 'vehicleTypeDifferent',
        matchTimeBegin: initBeginTime()
      },
    },
    output: {
      value: {
        rows: []
      },
    }
  },
  // 交易缺失
  tradeMissList: {
    input: {
      value: {
        page: 1,
        pageSize: 10,
        // queryState: 2,
        queryType: 'dataLose',
        matchTimeBegin: initBeginTime()
      },
    },
    output: {
      value: {
        rows: []
      },
    }
  },
  // badge数量
  badge: {
    conflict: 0,
    tradeMiss: 0
  },
  // 语音队列
  textQueue: []
};

export let computed = {};

function initBeginTime() {
  const d = new Date();
  // const d = new Date('2020-09-14 16:57:25');
  // 立即查询10秒前的数据
  return new Date(d.getTime() - 10000).format('yyyy-MM-dd hh:mm:ss');
}
